import React from "react";
import { useSnapshot } from "valtio";
import classnames from "classnames";
import { useTranslation } from "react-i18next/";
import { CheckboxIcon, VerticalDotsIcon } from "@aureskonnect/react-ui";
import { toast } from "react-toastify";
import { uuid } from "uuidv4";

import { store, setIsLoading, setKey } from "../store";
import { store as ModeOfSale } from "../../../../components/VerticalLayout/store";

import ErrorToast from "@components/Common/ErrorTost";
import { ConfirmationArchive } from "../ConfirmationArchive";
import { useFetchGlobal } from "../../../../api/hooks";

export function ActionColumnDevise({
    setIsHistoryModalOpened,
    isHistoryModalOpened,
    selectedRows,
    setDataIsUpdated,
    isDeviseArchived,
    setIsDeviseArchived,
    setLimit,
}: any) {
    const { t } = useTranslation();
    const { fetchGlobal } = useFetchGlobal();
    const {
        numberActiveMultiShop,
        numberArchiveMultiShop,
        deviceData,
        dataShops,
        modify,
        isLoading,
    } = useSnapshot(store);
    const { franchiseID, userID, oneShop, operatorID } = useSnapshot(
        ModeOfSale
    );
    const [isArchiveModalOpened, setIsArchiveModalOpened] = React.useState<
        boolean
    >(false);
    const uuidUser = localStorage.getItem("uuidUser");

    const getArrayOfRows = () => {
        let arrayOfRows: any[] = [];
        selectedRows.forEach(async (el: any) => {
            if (el[t("Shop")] === undefined) {
                arrayOfRows.push(el);
            }
        });
        return arrayOfRows;
    };

    let arrayOfRows = getArrayOfRows();
    let dataArchive: any[] = [];
    const getIsArrayOfRowsShop = () => {
        let isArrayShop: boolean = false;
        selectedRows.forEach(async (el: any) => {
            if (Object.values(el).includes(el.id)) {
                isArrayShop = true;
            }
        });
        return isArrayShop;
    };
    let isArrayShop = getIsArrayOfRowsShop();

    if (!oneShop) {
        dataArchive = archiveDevise();
    }
    function archiveDevise() {
        let idsAssociated: any = [];
        if (deviceData !== undefined) {
            deviceData.forEach((element: any) => {
                idsAssociated.push(element.id);
            });
        }
        idsAssociated = [...new Set(idsAssociated)];
        return idsAssociated;
    }

    function shopsIdArchiveDevise(e: any) {
        let idsAssociated: any = [];
        let shopSelectedRows: any[] = [];
        selectedRows.forEach((el: any) => {
            if (el.idShop === e.idShop) {
                shopSelectedRows.push(el.idShop);
            }
        });

        if (dataShops !== undefined) {
            dataShops.forEach((element: any) => {
                if (
                    element.subRows !== undefined &&
                    element.subRows.length === 0 &&
                    ((element.archivedDevices !== undefined &&
                        element.archivedDevices.length === 1) ||
                        (selectedRows.subRows === undefined &&
                            shopSelectedRows.length === 1))
                ) {
                    element.archivedDevices.forEach((el: any) => {
                        if (el.id === e.id && el.idShop === e.idShop)
                            idsAssociated.push(el.idShop);
                    });
                }
            });
        }

        idsAssociated = [...new Set(idsAssociated)];

        return idsAssociated;
    }
    async function activeDevise() {
        setIsLoading(true);
        toast.dismiss();

        try {
            let hasValidDevises = false;
            let hasEmptyShops = false;

            const devisesData: Record<string, any> = {};
            const allShopIds: string[] = [];

            for (const row of selectedRows) {
                if (row.Boutique !== undefined) {
                    continue;
                }

                const shopsIdArchived = shopsIdArchiveDevise(row);

                if (shopsIdArchived.length === 0) {
                    hasEmptyShops = true;
                    continue;
                }

                hasValidDevises = true;

                devisesData[row.id] = {
                    Nom_d_Affichage: row[t("Display name")],
                    tag: row[t("Tag")],
                    symbole: row[t("Symbol")],
                    Nbr_décimale: row[t("Nbr decimal")],
                    designation_décimale: row[t("Decimal designation")],
                    devise: row[t("Currency")],
                    pays: row[t("Country")],
                    shopId: shopsIdArchived, // Inclure les shops pour cette devise
                    isActive: false,
                    isArchived: false,
                };

                allShopIds.push(...shopsIdArchived);
            }

            if (!hasValidDevises) {
                if (hasEmptyShops) {
                    ErrorToast(
                        t("Attention,a shop cannot have more than one currency")
                    );
                }
                setIsLoading(false);
                setDataIsUpdated?.(true);
                setLimit(2);
                return;
            }

            const uniqueShopIds = [...new Set(allShopIds)];
            const payload = {
                userId: userID,
                shopId: uniqueShopIds,
                franchiseId: franchiseID,
                operatorId: operatorID,
                uuidUser: uuidUser,
                data: devisesData,
            };

            const apiUrl = `${process.env.REACT_APP_API_V2_URL}/settings/general/devise`;
            const response: any = await fetchGlobal(apiUrl, {
                method: "POST",
                headers: {
                    "Content-Type": "application/json",
                },
                body: JSON.stringify(payload),
            });

            if (response.error) {
                throw new Error(response.message || "Activation failed");
            }

            toast.success(t("The Currency was successfully unarchived"), {
                position: toast.POSITION.TOP_CENTER,
                theme: "colored",
                icon: <CheckboxIcon height={25} width={25} fill="white" />,
            });

            setKey(uuid());

            if (hasEmptyShops) {
                ErrorToast(
                    t("Attention,a shop cannot have more than one currency")
                );
            }

            setDataIsUpdated?.(true);
        } catch (error) {
            toast.error(t("There's an error"), {
                position: toast.POSITION.TOP_CENTER,
                autoClose: 2000,
                theme: "colored",
                closeOnClick: true,
                pauseOnHover: true,
                draggable: true,
            });
        } finally {
            setIsLoading(false);
            setLimit(2);
        }
    }

    return (
        <React.Fragment>
            <div>
                <div className="dropdown">
                    <VerticalDotsIcon
                        id="dropdownMenuButton1"
                        data-bs-toggle="dropdown"
                        style={{ cursor: "pointer" }}
                        height={25}
                        width={25}
                        fill="black"
                        className="cmn_drp_BTmenu"
                    />
                    <div
                        className="dropdown-menu"
                        aria-labelledby="dropdownMenuButton"
                    >
                        <div
                            className="dropdown-item pl-1 cmn_btn_BTlistActivated"
                            style={{ cursor: "pointer" }}
                            onClick={() => {
                                setIsDeviseArchived(false);
                                setDataIsUpdated(true);
                            }}
                        >
                            {t("currency activated")} ({numberActiveMultiShop})
                        </div>
                        <div
                            className="dropdown-item pl-1 cmn_btn_BTlistArchived"
                            style={{ cursor: "pointer" }}
                            onClick={() => {
                                setIsDeviseArchived(true);
                                setDataIsUpdated(true);
                            }}
                        >
                            {t("currency Archived")}({numberArchiveMultiShop})
                        </div>
                        <div
                            style={{ cursor: "pointer" }}
                            className={`${classnames(
                                " dropdown-item pl-1 pointer__clz cmn_btn_BThistory",
                                {
                                    "not-allowed-icon__clz":
                                        selectedRows.length === 0 ||
                                        arrayOfRows.length === 0 ||
                                        !isArrayShop,
                                }
                            )}`}
                            onClick={() => {
                                if (arrayOfRows.length < 2) {
                                    ErrorToast(
                                        `${t(
                                            "Attention, it is a multiple action. Please select at least two items"
                                        )!}`
                                    );
                                } else {
                                    setIsHistoryModalOpened(
                                        !isHistoryModalOpened
                                    );
                                }
                            }}
                        >
                            {t("Historical")}
                        </div>
                        {modify === true ? (
                            <>
                                <div
                                    style={{ cursor: "pointer" }}
                                    className={`${classnames(
                                        " dropdown-item pl-1 pointer__clz cmn_btn_BTunarchive cmn_btn_BTarchived",
                                        {
                                            "not-allowed-icon__clz":
                                                isLoading ||
                                                selectedRows.length === 0 ||
                                                arrayOfRows.length === 0 ||
                                                (arrayOfRows.some(
                                                    (element: any) =>
                                                        dataArchive.includes(
                                                            element.id
                                                        )
                                                ) &&
                                                    isDeviseArchived) ||
                                                !isArrayShop ||
                                                arrayOfRows.length === 1,
                                        }
                                    )}`}
                                    onClick={() => {
                                        setIsLoading(true);
                                        if (arrayOfRows.length < 2) {
                                            ErrorToast(
                                                `${t(
                                                    "Attention, it is a multiple action. Please select at least two items"
                                                )!}`
                                            );
                                            setIsLoading(false);
                                        } else if (isDeviseArchived) {
                                            activeDevise();
                                        } else {
                                            setIsLoading(false);
                                            setIsArchiveModalOpened(
                                                !isArchiveModalOpened
                                            );
                                        }
                                    }}
                                >
                                    {isDeviseArchived
                                        ? `${t("Dearchive")}`
                                        : `${t("Archive")}`}
                                </div>
                            </>
                        ) : null}
                    </div>
                </div>
            </div>
            {isArchiveModalOpened ? (
                <ConfirmationArchive
                    isModalOpened={isArchiveModalOpened}
                    setIsModalOpened={setIsArchiveModalOpened}
                    setDataIsUpdated={setDataIsUpdated}
                    selectedRows={selectedRows}
                />
            ) : null}
        </React.Fragment>
    );
}
